<template>
  <div>
    <the-header-second-row
      :is-mobile-fixed="isMobileLayout"
      class="border-bottom-0"
    >
      <filters
        @campaign-filters:update="updateFilters($event)"
        :filters-data="filtersData"
      />
    </the-header-second-row>
    <div class="d-flex align-items-center mb-4">
      <div class="mr-auto">
        <h1>
          {{ $t('bountyCampaigns') }}
          <!-- <span
            v-if="campaignList"
            class="text-primary ml-3"
            style="font-size: 60%; font-weight: normal;"
          >
            {{ campaignList.length }} offers
          </span> -->
        </h1>
      </div>
    </div>
    <list-bounty-campaign
      :list="campaignList"
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="busy"
      infinite-scroll-distance="10"
    />
    <list-empty v-if="!hasMore" />
  </div>
</template>

<script>
import ListBountyCampaign from '@/components/BountyCampaign/ListBountyCampaign.vue';
import ListEmpty from '@/components/BountyCampaign/ListEmpty.vue';
import { loadingMixin } from '@/utils/mixins.js';
import campaignsMixin from './mixins/campaigns.js';
import Filters from './components/Filters.vue';

export default {
  head: {
    title() {
      return {
        inner: this.$t('metaTitle.bountyCampaigns')
      };
    }
  },

  components: {
    ListBountyCampaign,
    Filters,
    ListEmpty
  },

  mixins: [loadingMixin, campaignsMixin]
};
</script>
